export type TypeGenCommentStyle = '//' | '#';

const AUTOGENERATED_BANNER_LINES = [
  '🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑',
  '🛑 THIS IS AN AUTOGENERATED FILE - DO NOT EDIT DIRECTLY 🛑',
  '🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑',
];

export function getAutogeneratedBanner(commentStyle: TypeGenCommentStyle): string {
  // no leading blank line — a blank first line is non-idiomatic everywhere and gofmt strips it
  return AUTOGENERATED_BANNER_LINES.map((line) => `${commentStyle} ${line}`).join('\n');
}
